"use client";

import { createRankColumns } from "@/features/rank-list/shared/config";
import { TopSellerItem } from "@/types";
import { RANK_LIST_CONFIGS } from "@/features/rank-list/shared";

export const topSellerColumns = createRankColumns<TopSellerItem>(
  RANK_LIST_CONFIGS.topsellers.primaryColor
);
